import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';

import { round4 as round } from 'utilities/math';

import Input from 'components/Input';

class CutoffFieldComponent extends React.PureComponent {
  constructor (props) {
    super(props);

    this.formatFn = value =>
      value || value === 0
        ? round(value)
        : '';
  }

  render () {
    return (
      <Field
        step={0.1}
        type="number"
        component={Input}
        format={this.formatFn}

        labelClassName="main-input__label"
        inputClassName={`main-input__input max-85 pr-5  ml-3 mt-20 ${this.props.inputClass}`}
        wrapperClassName={`relative flex baseline justify-end iconTop ${this.props.wrapperClass}`}
        {...this.props}
      />
    );
  }
}

CutoffFieldComponent.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  inputClass: PropTypes.string,
  wrapperClass: PropTypes.string.isRequired,
  validate: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired
};

export default CutoffFieldComponent;
